import * as React from 'react';
import { Dialog, DialogTitle, DialogActions, Button, DialogContent, Typography, useTheme} from '@mui/material';
import { useTranslation } from 'react-i18next';

interface Props {
  open: boolean;
  onClose: () => void;
  loading: boolean;
  onConfirm: () => void;
  ns: string;
  email?: string;
}

const DeleteDialog: React.FC<Props> = ({
  open,
  onClose,
  onConfirm,
  loading,
  ns,
  email,
}: Props) => {
    const theme = useTheme();

    const { t } = useTranslation();
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle sx={{ fontWeight: 'bold' }}>
        {t(`${ns}:t.deleteConfirm`)}
      </DialogTitle>
      <DialogContent>
        <Typography variant="body1" sx={{ mb: 2 }}>
          {t(`${ns}:t.deleteConfirmText`)}
        </Typography>
        {email && (
          <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
            {email}
          </Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button
          color="secondary"
          onClick={onClose}
          sx={{
              ...theme.typography.buttons,
            background: 'var(--V_Green_1F9122, #1F9122)',
            color: '#FFF',
          }}
        >
          {t('common:t.cancel')}
        </Button>
        <Button color="primary" onClick={onConfirm} disabled={loading}
                sx={{
                    ...theme.typography.buttons,
                    color: 'var(--V_Green_1F9122, #1F9122)',
                    border: '1px solid #1F9122',
                }}>
          {t(`${ns}:t.deleteUser`)}

        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteDialog;
